import { render } from "./ShopLeftSidebarPage.vue?vue&type=template&id=59674618&ts=true"
import script from "./ShopLeftSidebarPage.vue?vue&type=script&lang=ts"
export * from "./ShopLeftSidebarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__